import React, {useEffect, useState} from "react";
import Api from '../../../../interface/api/visit';
import './Style.css';

export default function VisitQRCode(props) {
    const {match} = props;

    const [ visitorInfo, setVisitorInfo ] = useState<any>();

    useEffect(() => {
        console.log(match.params.visitInfoSeq);
        Api.getVisitorInfo2(match.params.visitInfoSeq).then(res => setVisitorInfo(res.data));
    }, [match.params.visitInfoSeq])

    return visitorInfo!==undefined && (

        <div className="nv_qrcode_wrap">
            <div className="nv_qrcode_box">
                <h1 className="qrcode_logo">솔브레인</h1>
                <div className="qr_img" id="qrcode">
                    {
                        visitorInfo.fileInfo!==undefined && <img src={`/qrcode/${visitorInfo.fileInfo.saveFileName}`}/>
                    }
                </div>
                <div className="nv_modal_contents">
                    <table className="nv_table">
                        <thead>
                        <tr>
                            <td scope="row" className="textcenter">신청자</td>
                            <td className="textcenter">{visitorInfo.name}</td>
                        </tr>
                        <tr>
                            <td scope="row" className="textcenter">접견인</td>
                            <td className="textcenter">{visitorInfo.visitorApplicationInfo.hostInfo.name}</td>
                        </tr>
                        <tr>
                            <td scope="row" className="textcenter">방문 일자</td>
                            <td className="textcenter">{`${visitorInfo.visitorApplicationInfo.startDate} ${visitorInfo.visitorApplicationInfo.startTime}시 ~ ${visitorInfo.visitorApplicationInfo.endDate} ${visitorInfo.visitorApplicationInfo.endTime}`}</td>
                        </tr>
                        <tr>
                            <td scope="row" className="textcenter">방문 목적</td>
                            <td className="textcenter">{`${visitorInfo.visitorApplicationInfo.visitPurpose}-${visitorInfo.visitorApplicationInfo.visitPurposeDetail}`}</td>
                        </tr>
                        <tr>
                            <td scope="row" className="textcenter">방문 위치</td>
                            <td className="textcenter">{`${visitorInfo.visitorApplicationInfo.visitLocation}`}</td>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    )
}